export const normalizeRoleValue = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, "-");

export const normalizePositiveInt = (value) => {
  const numeric = Number(value);
  return Number.isInteger(numeric) && numeric > 0 ? numeric : null;
};

export const ELIGIBLE_FINANCE_ROLES = new Set([
  "finance-rep",
  "finance",
  "administrator",
  "admin",
  "superadmin",
  "super-administrator",
]);

export const isEligibleFinanceRecipient = (user) =>
  ELIGIBLE_FINANCE_ROLES.has(normalizeRoleValue(user?.role)) ||
  ELIGIBLE_FINANCE_ROLES.has(normalizeRoleValue(user?.globalRole));

export const normalizeFinanceRecipientIds = (ids) =>
  Array.isArray(ids)
    ? Array.from(
        new Set(ids.map((id) => normalizePositiveInt(id)).filter(Boolean))
      )
    : [];

export const buildFinanceRecipientOption = (user) => {
  const id = normalizePositiveInt(user?.id);
  if (!id) return null;

  const firstName = String(user?.first_name || "").trim();
  const lastName = String(user?.last_name || "").trim();
  const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();
  const email = String(user?.email || "").trim();
  const role = String(user?.role || "").trim();
  const globalRole = String(user?.globalRole || "").trim();
  const normalizedRole = normalizeRoleValue(role);
  const normalizedGlobalRole = normalizeRoleValue(globalRole);

  return {
    id,
    firstName,
    lastName,
    fullName,
    email,
    role,
    globalRole,
    normalizedRole,
    normalizedGlobalRole,
    label: fullName || email || "User #" + id,
    searchText: [
      firstName,
      lastName,
      fullName,
      email,
      role,
      normalizedRole,
      globalRole,
      normalizedGlobalRole,
      id,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase(),
  };
};

export const buildFinanceRecipientOptions = (users) =>
  (Array.isArray(users) ? users : [])
    .filter(isEligibleFinanceRecipient)
    .map(buildFinanceRecipientOption)
    .filter(Boolean)
    .sort((left, right) => {
      const byLast = left.lastName.localeCompare(right.lastName, undefined, { sensitivity: "base" });
      if (byLast !== 0) return byLast;
      const byFirst = left.firstName.localeCompare(right.firstName, undefined, { sensitivity: "base" });
      if (byFirst !== 0) return byFirst;
      const byEmail = left.email.localeCompare(right.email, undefined, { sensitivity: "base" });
      if (byEmail !== 0) return byEmail;
      return left.id - right.id;
    });

export const filterFinanceRecipientOptions = (options, inputValue) => {
  const rawInput =
    inputValue && typeof inputValue === "object"
      ? inputValue.inputValue
      : inputValue;
  const normalized = String(rawInput || "").trim().toLowerCase();
  if (!normalized) return options;
  return options.filter((option) => option.searchText.includes(normalized));
};
